import { OrderStatus } from '@utility/constants/common';

/*
 * Picking orders to fulfill is not batching: there is no shared warehouse and
 * no manual-provider rule, only "the details page can act on this order".
 */

export type FulfillCandidate = {
  _id: string;
  state?: string;
  status?: string;
  shipping_state?: string;
  updated?: boolean;
  loading?: boolean;
  virtuallyCompleted?: boolean;
};

/** A fulfillment request already owns the order, so there is nothing to do. */
export function isOrderBusy(order: FulfillCandidate): boolean {
  if (order.virtuallyCompleted) {
    return true;
  }
  if (order.updated) {
    return false;
  }
  return (
    !!order.loading ||
    order.status === 'pending' ||
    order.shipping_state === 'pending'
  );
}

/** Mirrors what the details page will actually offer to fulfill. */
export function canFulfillOrder(order: FulfillCandidate): boolean {
  return order.state === OrderStatus.PendingShipment && !isOrderBusy(order);
}

export function canStartFulfilling(orders: FulfillCandidate[]): boolean {
  return (orders || []).some(canFulfillOrder);
}

/** The queue follows the list, not the order the user happened to tick. */
export function getFulfillQueue(
  orders: FulfillCandidate[],
  selected: Record<string, unknown>,
): string[] {
  return (orders || [])
    .filter(order => selected?.[order._id] && canFulfillOrder(order))
    .map(order => order._id);
}
